import React from "react";
import LevelTile from "../components/recording/LevelTile";

/**
 * Level-selection landing page.
 *
 * Presents two `<LevelTile>` buttons in a 2-column grid.
 * • **Level 1** routes to the guide + 60-second scan.
 * • **Level 2** is a disabled placeholder until the advanced workflow is ready.
 *
 * @component
 * @returns {JSX.Element}
 */
export default function LevelSelectionPage() {
  return (
    <div className="w-full flex flex-col justify-between md:justify-start items-center p-8 gap-6 max-w-lg">
      <h1 className="subtitle-text">Choose an Assessment Type</h1>

      <div className="w-full grid grid-cols-2 gap-4">
        {/* ——— Enabled tile ——— */}
        <LevelTile
          to="/recording/lvl1/guide"
          title="Level 1"
          desc="60-second basic scan"
        />

        {/* ——— Placeholder tile ——— */}
        <LevelTile title="Level 2" desc="Coming soon" disabled={true} />
      </div>
    </div>
  );
}
